import React from 'react';
import './DashboardTablePage.css';
import Sidebar from '../../components/sidebar/Sidebar';
import AddPartnerForm from "../../components/pageManager/AddPartnerForm";

const AddPartnerFormPage = () => {
    return (
        <div className={"dashboard-page"}>
            <div className="dashboard-bggg">
                <div className="dashboard-flex-containerr">
                    <Sidebar />
                    <AddPartnerForm />
                </div>
            </div>
        </div>
    );
};

export default AddPartnerFormPage;
